export default "__VITE_ASSET__13xXO72m__"